import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import { setDictionaryFileStructure } from '../../actions/rldToolActions';
import CommonDropdown from '../common/CommonDropdown';
import { RldConstant } from './RldConstant';

const RldDictionaryFileFormat = () => {
  const dictionaryFileFormat = useSelector(
    ({ rldTool }) => rldTool.dictionaryFileFormat
  );
  const dispatch = useDispatch();

  const [selectedExport, setSelectedExport] = useState(null);

  useEffect(() => {
    const dictFormat = _.find(RldConstant.dictionaryFormats, {
      value: dictionaryFileFormat,
    });
    setSelectedExport(dictFormat);
  }, [dictionaryFileFormat]);

  const changeExportFormat = e => {
    dispatch(setDictionaryFileStructure(e.value));
  };

  return (
    <div>
      <div className="account_component">
        <div className="account_selector">
          <div className="account_item export_format">
            <CommonDropdown
              listData={RldConstant.dictionaryFormats}
              defaultSelected={selectedExport}
              itemClickFn={changeExportFormat}
              filterSearch={false}
              placeHolder="Select Dictionary Format"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RldDictionaryFileFormat;
